const enum SamplingTypes {
  REGULAR = 0,
  ISNT_1 = 1,
  ISNT_2 = 2,
  CYST = 3,
}

export default SamplingTypes;
